import { axiosInstance } from '../Config/axios';

const API_URL = `v1/assetia/`;

// Función para listar los consejos (GET)
export const getAssetia = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los consejos:', error);
    throw error;
  }
};